import React, { useState } from 'react';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import OutletList from './OutletList';
import DeviceLogs from './DeviceLogs';
import BillingHistory from './BillingHistory';
import OutletAction from './OutletAction';
import FeatureSubscriptions from './FeatureSubscriptions';
import OutletSlotAction from './OutletSlotAction';
import OutletActivityLogs from './OutletActivityLogs';
import styles from './BusinessDetailSections.module.css';

const OutletSection = () => {
  const [activeItem, setActiveItem] = useState('Outlet List');

  const handleItemClick = (e, { name }) => {
    setActiveItem(name);
  };

  return (
    <div className={styles.section}>
      <Grid>
        <Grid.Column stretched width={3}>
          <Menu fluid vertical tabular>
            <Menu.Item
              name="Outlet List"
              active={activeItem === 'Outlet List'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="Devices"
              active={activeItem === 'Devices'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="Billing History"
              active={activeItem === 'Billing History'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="Outlet Action"
              active={activeItem === 'Outlet Action'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="Feature Subscriptions"
              active={activeItem === 'Feature Subscriptions'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="Outlet Slot Action"
              active={activeItem === 'Outlet Slot Action'}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="Outlet Activity Logs"
              active={activeItem === 'Outlet Activity Logs'}
              onClick={handleItemClick}
            />
          </Menu>
        </Grid.Column>
        <Grid.Column stretched width={13}>
          <div className={styles['item-component']}>
            <Segment>
              {(() => {
                switch (activeItem) {
                  case 'Outlet List':
                    return <OutletList />;
                  case 'Devices':
                    return <DeviceLogs />;
                  case 'Billing History':
                    return <BillingHistory />;
                  case 'Outlet Action':
                    return <OutletAction />;
                  case 'Feature Subscriptions':
                    return <FeatureSubscriptions />;
                  case 'Outlet Slot Action':
                    return <OutletSlotAction />;
                  case 'Outlet Activity Logs':
                    return <OutletActivityLogs />;
                  default:
                    return <></>;
                }
              })()}
            </Segment>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default OutletSection;
